import Header from '../components/Header'
import Footer from '../components/Footer'
import { CheckCircle } from 'lucide-react'

const CompliancePage = () => {
  const items = [
    { title: 'State Bank of Pakistan (SBP)', description: 'MobiPay operates in full compliance with all regulations and guidelines issued by the State Bank of Pakistan for payment service providers.' },
    { title: 'Anti-Money Laundering (AML)', description: 'We maintain strict AML policies and procedures, including customer due diligence, transaction monitoring, and suspicious activity reporting.' },
    { title: 'Know Your Customer (KYC)', description: 'All merchants are subject to our KYC verification process to ensure the integrity of our platform and prevent fraudulent activity.' },
    { title: 'Data Protection', description: 'We comply with applicable data protection laws in Pakistan, ensuring your personal and business data is handled responsibly and securely.' },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="gradient-bg text-white py-16">
        <div className="container-max section-padding text-center">
          <h1 className="text-4xl font-bold mb-4">Compliance</h1>
          <p className="text-blue-100 text-lg max-w-2xl mx-auto">We are committed to operating with full regulatory compliance and the highest ethical standards.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="container-max section-padding max-w-4xl mx-auto space-y-6">
          {items.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex items-start space-x-5">
              <div className="flex-shrink-0 mt-1">
                <CheckCircle className="h-7 w-7 text-orange-500" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Compliance Inquiries</h2>
            <p className="text-gray-600 leading-relaxed mb-3">For compliance-related questions or to request documentation, please reach out to our compliance team.</p>
            <a href="mailto:support@mobipay.pk" className="text-orange-500 font-semibold hover:text-orange-600 transition-colors">support@mobipay.pk</a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}

export default CompliancePage
